import {
  Box,
  Button,
  Group,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconArrowUp, IconCheck, IconX } from "@tabler/icons-react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { createComboSet } from "../../api/ApiComboSet";
import { ComboSet, tblComboSetGroupModels } from "../../model/Comboset";
import ItemGroupV2 from "./ItemGroupV2";
import { useState, useEffect, useRef } from "react";
import BreadCrumb from "../../_base/component/_layout/_breadcrumb";

const CreateView = () => {
  const navigate = useNavigate();
  const entity = {
    setName: "",
    description: "",
    status: "",
    visible: "",
    fromDate: "",
    toDate: "",
    fromHour: null,
    toHour: null,
    isActualStore: "",
    tblComboSetGroupCommands: [],
  };

  const handleCreateComboSet = async (dataSubmit: ComboSet) => {
    open();
    const startDate = dataSubmit.fromDate;
    const endDate = dataSubmit.toDate;
    const editData = {
      ...dataSubmit,
      tblComboSetGroupCommands: dataComboSetGroup,
    };
    if (startDate && endDate) {
      const startDateObject = new Date(startDate);
      const endDateObject = new Date(endDate);

      if (startDateObject >= endDateObject) {
        NotificationExtension.Warn("Ngày bắt đầu phải trước ngày kết thúc!");
      } else {
        await createComboSet(editData);
        navigate("/combo/combo-set");
      }
    } else {
      await createComboSet(editData);
      navigate("/combo/combo-set");
    }
    close();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [dataComboSetGroup, setDataComboSetGroup] = useState<
    tblComboSetGroupModels[]
  >([]);

  const form = useForm<ComboSet>({
    initialValues: {
      ...entity,
    },
    validate: {
      setName: isNotEmpty("Tên set chưa nhập"),
      // description: isNotEmpty("Mô tả tóm tắt chưa nhập"),
      status: isNotEmpty("Trạng thái chưa chọn"),
      visible: isNotEmpty("Hiển thị chưa chọn"),
    },
  });

  return (
    <>
      <Box
        component="form"
        // mx="auto"
        // px={64}
        onSubmit={form.onSubmit((e: ComboSet) => {
          handleCreateComboSet(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <BreadCrumb />
          <Box style={{ display: "flex", gap: 8 }}>
            <Button
              variant="outline"
              color="red"
              type="button"
              onClick={() => navigate("/combo/combo-set")}
              loading={visible}
              leftSection={!visible ? <IconX size={18} /> : undefined}
            >
              Đóng
            </Button>
            <Button
              variant="outline"
              type="submit"
              color="#3598dc"
              loading={visible}
              leftSection={!visible ? <IconCheck size={18} /> : undefined}
            >
              Lưu
            </Button>
          </Box>
        </Box>
        <Group grow wrap="wrap" gap={"lg"}>
          <TextInput
            label={"Tên set"}
            placeholder={"Nhập tên set"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("setName")}
          />
          <TextInput
            label={"Mô tả tóm tắt"}
            placeholder={"Nhập mô tả tóm tắt"}
            // withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("description")}
          />
          <DateTimePicker
            disabled={form.values.visible === "I" || null ? false : true}
            value={
              form.getInputProps("fromDate").value
                ? new Date(form.getInputProps("fromDate").value)
                : null
            }
            onChange={(value) =>
              form
                .getInputProps("fromDate")
                .onChange(moment(value).format("YYYY-MM-DD[T]HH:mm:ss"))
            }
            mt="md"
            label="Ngày bắt đầu"
            placeholder="Ngày bắt đầu"
          />
        </Group>

        <Group grow wrap="wrap" gap={"lg"}>
          <Select
            label={"Trạng thái"}
            placeholder={"Hiển thị/Không hiển thị"}
            withAsterisk
            mt="md"
            data={[
              { value: "A", label: "Hiển thị" },
              { value: "I", label: "Không hiển thị" },
            ]}
            {...form.getInputProps("status")}
          />
          <Select
            label={"Loại hiển thị"}
            placeholder={"Luôn hiển thị/Thời gian hiển thị"}
            withAsterisk
            mt="md"
            data={[
              { value: "A", label: "Luôn hiển thị" },
              { value: "I", label: "Thời gian hiển thị" },
            ]}
            {...form.getInputProps("visible")}
          />
          <DateTimePicker
            disabled={form.values.visible === "I" || null ? false : true}
            value={
              form.getInputProps("toDate").value
                ? new Date(form.getInputProps("toDate").value)
                : null
            }
            onChange={(value) =>
              form
                .getInputProps("toDate")
                .onChange(moment(value).format("YYYY-MM-DD[T]HH:mm:ss"))
            }
            mt="md"
            label="Ngày kết thúc"
            placeholder="Ngày kết thúc"
          />
        </Group>
        <ItemGroupV2
          // onSetDataComboSet={handleSetDataComboSet}
          dataGroupItem={dataComboSetGroup || []}
          setDataGroupItem={setDataComboSetGroup}
        />
      </Box>
    </>
  );
};

export default CreateView;
